import { BUCKETS, STORAGE_API, contentPrefix, objectsApi } from "./config";
import { listAllObjects, markdownSlugs } from "./listing";

/** @typedef {{ fetch?: (url: string, init?: object) => Promise<any> }} FetchDeps */

/** Public URL of an object in the public bucket. */
export function gcsPublicUrl(path) {
	return `${STORAGE_API}/${BUCKETS.public}/${path}`;
}

/**
 * Read an object from the public bucket without credentials.
 * @param {string} path
 * @param {FetchDeps} [deps]
 * @returns {Promise<string | null>} null when the object does not exist; throws on other failures.
 */
export async function gcsReadPublic(path, { fetch: fetchImpl = fetch } = {}) {
	const res = await fetchImpl(gcsPublicUrl(path.split("/").map(encodeURIComponent).join("/")));
	if (res.ok) return res.text();
	if (res.status === 404) return null;
	throw new Error(`GCS read failed: ${res.status}`);
}

/**
 * List objects under a prefix of the public bucket without credentials. Needs
 * allUsers objectViewer on that prefix (an IAM condition on the bucket).
 * @param {string} prefix
 * @param {FetchDeps} [deps]
 */
export function gcsListPublic(prefix, { fetch: fetchImpl = fetch } = {}) {
	const url = objectsApi(BUCKETS.public);
	return listAllObjects(
		prefix,
		(params) => fetchImpl(`${url}?${params}`),
		"GCS public list failed",
	);
}

/**
 * Live entries of a type, for public pages: [{ slug, updated, size }]. Throws
 * when the listing cannot be fetched, because an empty array means "nothing
 * published" and the pages show a different message for each.
 * @param {string} type
 * @param {FetchDeps} [deps]
 */
export async function listPublished(type, deps = {}) {
	return markdownSlugs(await gcsListPublic(contentPrefix("production", type), deps));
}
